import React from "react";
import Button from "../../../../../common/forms/button";
import PlusIcon from "../../../../../common/icons/plusIcon";
import SignatureIllustration from "../../../../../common/icons/illustrations/signature";
import { clickToLinkHandler } from "../../../../../../helpers/utils";
import "./styles/index.scss";

const SignersPanelEmptyState = (props) => {
  const { orgId, dealId } = props;

  return (
    <div className="signers-panel-without-persons">
      <div className="signers-panel-without-persons-inner-container">
        <SignatureIllustration className="signers-panel-without-persons-icon" />
        <div className="signers-panel-without-persons-header-text">
          Need to add Investors
        </div>
        <div className="signers-panel-without-persons-sub-text">
          For adding signers were need to add any persons with right ot sign
          from investors side or board members first.
        </div>
        <Button
          type="secondary"
          size="medium"
          onClick={() => {
            clickToLinkHandler(
              `/${orgId}/deals/${dealId}/edit/investors/create`
            );
          }}
        >
          <div className="signers-page_empty-state-button-inner">
            <PlusIcon />
            Add investor to deal
          </div>
        </Button>
      </div>
    </div>
  );
};

export default SignersPanelEmptyState;
